import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {title} from "../../styles/globalStyleVars";
import {ImageParallaxNoLoad} from "../ImageParallaxNoLoad";
import {useLocation} from "react-router-dom";

const InnerBanner = ({data, title}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const location = useLocation();

    useEffect(() => {
        // Update the window width when the window is resized
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [location.pathname]);

    return (
        <StyledInnerBanner className='projectbanner'>
            {
                windowWidth > 767 ?
                    <ImageParallaxNoLoad banner={true} src={data?.[0]?.images?.filter(image => image?.desktop === 'on')?.[0]?.full_path}/>
                    :
                    <ImageParallaxNoLoad banner={true} src={data?.[0]?.images?.filter(image => image?.mobile === 'on')?.[0]?.full_path}/>
            }

            <Container>
                <Row>
                    <Col>
                        <h3 className={''}>{title ? reactHtmlParser(title) : ''}</h3>
                        {reactHtmlParser(data?.[0]?.data?.description)}
                    </Col>
                </Row>
            </Container>
        </StyledInnerBanner>
    );
};

const StyledInnerBanner = styled.section`
  padding-top: calc(636 / 1366 * 100%);
  position: relative;
    overflow: hidden;
    
  &:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    z-index: 1;
    left: 0;
    top: 0;
  }
  .container {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 60px;
    z-index: 2;
  }

  h3 {
    font-family: ${title};
    color: #F9F9F9;
    z-index: 2;
  }
  ul{
    margin-top: 15px;
    display: flex;
    align-items: center;
    li{
      display: flex;
      align-items: center;
      margin-right: 30px;
      &:last-child{
        margin-right: 0;
      }
      p{
        margin-bottom: 0;
        margin-left: 15px;
        font-size: 14px;
        line-height: 24px;
        color: #fff;
      }
    }
  }
  @media (min-width: 767px) {
    .title {
      width: 50%;
    }
  }

  @media (max-width: 767px) {
    //padding-top: 0;
    padding-top: calc(550 / 375 * 100%);
    .container {
      //left: 25px;
      bottom: 40px;
    }


    h3 {
      font-size: 50px;
      line-height: 50px;
    }
    
  }
  
  @media(max-width: 1198px){
    ul{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      li{
        margin-right: 20px;
      }
    }
  }

  @media (min-width: 1200px) and (max-width : 1500px){
    ul{
      li{
        margin-right: 20px;
      }
    }
  }
`;

export default React.memo(InnerBanner);
